<template>
  <div>
    <Spin fix v-if="loadingGroup">加载中..</Spin>
    <span>供应商名称：</span>
    <Input style="width:300px;margin-right:5px;" v-model="searchName"></Input>
    <Button type="primary" @click="getSearch">搜索</Button>
    <Table :columns="bidCompanyColumns" :data="platformSuppliers" style="margin-top:5px;"></Table>
    <Page show-elevator @on-change="pageChange" :total="total" style="margin-top:5px;"></Page>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'

export default {
  data() {
    return {
      loadingGroup: false,
      bidCompanyColumns: [
        {
          title: '投标单位',
          render: (h, params) => {
            return h('div', params.row.abpEnroll.companyName)
          }
        },
        {
          title: '项目编号',
          width: 180,
          render: (h, params) => {
            return h('div', params.row.abpEnroll.projectFull)
          }
        },
        {
          title: '中标金额',
          width: 100,
          key: 'winAmount'
        },
        {
          title: '应收款',
          width: 100,
          key: 'receivable'
        },
        {
          title: '包组',
          width: 60,
          key: 'groupNumber'
        },
        {
          title: '是否中标',
          width: 85,
          key: 'isWin',
          render: (h, params) => {
            let status = '否'
            if (params.row.status) {
              status = '是'
            }
            return h('div', status)
          }
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.selectSupplier(params.row)
                  }
                }
              }, '选择')
            ])
          }
        }
      ],
      platformSuppliers: [],
      searchName: '',
      total: 0
    }
  },
  mounted() {
    // this.getGroupEnroll(1)
    this.getEnroll(1, this.searchName)
  },
  methods: {
    // 获取当前项目所有包组的所有报名供应商
    async getGroupEnroll(page) {
      // 这个获取有点慢，加个遮罩
      this.loadingGroup = true
      let rep = await ajax.get(requestUrls.YbDb.getPaged, {
        params: {
          filter: `groupId > 0 and companyName.contains("${this.searchName}")`,
          soting: 'id desc',
          maxResultCount: 8,
          skipCount: (page - 1) * 8,
        }
      })
      this.loadingGroup = false
      if (rep.data.success) {
        this.platformSuppliers = rep.data.result.items
        this.total = rep.data.result.totalCount
      }
    },
    async getEnroll(page, companyName) {
      let rep = await ajax.get(requestUrls.enroll.GetPagedExt, {
        params: {
          filter: `status=="true" and abpEnroll.companyName.contains("${companyName}")`,
          sorting: 'abpEnroll.creationTime desc',
          maxResultCount: '10',
          skipCount: (page - 1) *10
        }
      })
      if (rep.data.success) {
        this.platformSuppliers = rep.data.result.items
        this.total = rep.data.result.totalCount
      }
    },
    pageChange(page) {
      this.getEnroll(page, this.searchName)
    },
    getSearch() {
      this.getEnroll(1, this.searchName)
    },
    selectSupplier(row) {
      this.$emit('endImport', row)
    }
  }
}
</script>
